import React from 'react';

const DecorativeBannerBackground: React.FC = () => (
  <svg
    viewBox="0 0 832 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
    }}
  >
    <g style={{ mixBlendMode: 'screen' }} opacity={0.7}>
      <path
        d="M217.526 361.844C200.08 257.169 268.424 144.933 424.258 125.454C549.867 109.753 840.338 173.43 876.101 -90"
        stroke="#00CA98"
        strokeWidth="1.30843"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M204.747 356.759C193.207 249.11 267.761 135.608 429.832 121.844C558.406 110.923 841.105 179.022 883.647 -77.0723"
        stroke="#00CA98"
        strokeWidth="1.27354"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M191.968 351.682C186.324 241.058 267.054 126.205 435.396 118.241C566.911 112.013 841.873 184.622 891.174 -64.1367"
        stroke="#00CA98"
        strokeWidth="1.22992"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M179.189 346.604C179.442 232.998 266.322 116.714 440.97 114.629C575.39 113.024 842.64 190.212 898.719 -51.21"
        stroke="#00CA98"
        strokeWidth="1.19503"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M166.419 341.519C172.577 224.938 265.563 107.136 446.553 111.018C583.868 113.966 843.417 195.804 906.274 -38.2822"
        stroke="#00CA98"
        strokeWidth="1.15142"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M153.64 336.442C165.695 216.887 264.795 97.4885 452.118 107.415C592.32 114.847 844.175 201.404 913.81 -25.3467"
        stroke="#00CA98"
        strokeWidth="1.11652"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M140.861 331.366C158.821 208.836 264.027 87.763 457.692 103.813C600.782 115.667 844.952 207.004 921.355 -12.4102"
        stroke="#00CA98"
        strokeWidth="1.08163"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M128.091 326.28C151.948 200.776 263.26 77.9493 463.275 100.193C609.252 116.426 845.728 212.586 928.901 0.507812"
        stroke="#00CA98"
        strokeWidth="1.03802"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M115.312 321.204C145.074 192.725 262.501 68.0931 468.84 96.5906C617.704 117.15 846.487 218.187 936.437 13.4531"
        stroke="#00CA98"
        strokeWidth="1.00313"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M102.533 316.118C138.192 184.656 261.751 58.1572 474.414 92.9788C626.183 117.83 847.263 223.778 943.982 26.3799"
        stroke="#00CA98"
        strokeWidth="0.959513"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M89.7539 311.042C131.318 176.605 261.018 48.1875 479.988 89.3768C634.67 118.476 848.031 229.379 951.519 39.3164"
        stroke="#00CA98"
        strokeWidth="0.924622"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M76.9834 305.965C124.444 168.554 260.311 38.1558 485.562 85.7651C643.166 119.078 848.799 234.969 959.064 52.2432"
        stroke="#00CA98"
        strokeWidth="0.881008"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M64.2046 300.88C117.571 160.494 259.623 28.0813 491.136 82.1543C651.68 119.654 849.566 240.561 966.61 65.1709"
        stroke="#00CA98"
        strokeWidth="0.846116"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M51.4258 295.803C110.689 152.443 258.951 17.9627 496.71 78.5516C660.211 120.212 850.343 246.161 974.155 78.1067"
        stroke="#00CA98"
        strokeWidth="0.811225"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M38.6553 290.726C103.824 144.392 258.305 7.81791 502.283 74.949C668.75 120.753 851.11 251.761 981.691 91.0426"
        stroke="#00CA98"
        strokeWidth="0.767611"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.8765 285.64C96.9415 136.331 257.677 -2.37063 507.858 71.3374C677.308 121.258 851.878 257.352 989.237 103.97"
        stroke="#00CA98"
        strokeWidth="0.732719"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M13.0977 280.564C90.0681 128.272 257.189 -12.9688 513.432 67.7263C685.961 121.503 852.646 262.944 996.782 116.897"
        stroke="#00CA98"
        strokeWidth="0.689105"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.327148 275.487C83.1942 120.221 256.482 -22.8342 519.005 64.1239C694.465 122.244 853.422 268.544 1004.33 129.833"
        stroke="#00CA98"
        strokeWidth="0.654214"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <g style={{ mixBlendMode: 'screen' }} opacity={0.7}>
      <path
        d="M393.727 423.776C302.138 343.526 269.13 4.05876 468.761 -31.0245C640.584 -61.2143 765.321 19.0359 836.168 78.3513C897.045 129.319 969.453 227.172 969.453 227.172"
        stroke="#00CA98"
        strokeWidth="1.30843"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M371.868 419.118C287.326 334.14 262.231 8.35928 457.518 -26.4274C625.372 -56.3119 749.219 20.5189 820.694 79.7035C884.344 132.11 958.061 230.905 961.262 239.916"
        stroke="#00CA98"
        strokeWidth="1.27354"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M350.008 414.468C272.523 324.763 255.331 12.6678 446.274 -21.8223C610.159 -51.3928 732.968 22.1932 805.219 81.0637C871.504 135.067 946.669 234.638 953.071 252.66"
        stroke="#00CA98"
        strokeWidth="1.23864"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M328.158 409.82C257.721 315.395 248.44 16.9776 435.039 -17.216C594.955 -46.4811 716.822 23.7553 789.754 82.4164C858.76 137.92 935.286 238.364 944.881 265.404"
        stroke="#00CA98"
        strokeWidth="1.20375"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M306.299 405.162C242.918 306.009 241.531 21.2867 423.795 -12.6191C579.751 -41.5702 700.685 25.2904 774.279 83.7684C846.016 140.764 923.894 242.088 936.69 278.148"
        stroke="#00CA98"
        strokeWidth="1.16014"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M284.448 400.513C228.116 296.632 234.641 25.5958 412.561 -8.01337C564.548 -36.6592 684.565 26.8257 758.814 85.1292C833.281 143.607 912.511 245.822 928.5 290.893"
        stroke="#00CA98"
        strokeWidth="1.12525"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M262.588 395.863C213.304 287.255 227.74 29.9046 401.316 -3.40799C549.335 -31.7398 668.445 28.3432 743.348 86.4897C820.563 146.442 901.127 249.563 920.317 303.645"
        stroke="#00CA98"
        strokeWidth="1.09036"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M240.737 391.204C198.51 277.869 220.849 34.2044 390.081 1.18844C534.13 -26.8381 652.351 29.843 727.882 87.8412C807.853 149.25 889.743 253.288 912.126 316.38"
        stroke="#00CA98"
        strokeWidth="1.05546"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M218.878 386.556C183.699 268.501 213.941 38.5228 378.838 5.79467C518.918 -21.9178 636.249 31.3439 712.408 89.2026C795.144 152.059 878.343 257.021 903.936 329.133"
        stroke="#00CA98"
        strokeWidth="1.02057"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M197.027 381.907C168.905 259.124 207.05 42.832 367.603 10.4004C503.723 -17.0068 620.164 32.8356 696.943 90.5634C782.453 154.86 866.96 260.755 895.745 341.877"
        stroke="#00CA98"
        strokeWidth="0.976959"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M175.168 377.248C154.093 249.738 200.15 47.1322 356.359 14.9972C488.51 -12.0959 604.07 34.3009 681.468 91.9153C769.752 157.633 855.568 264.479 887.554 354.621"
        stroke="#00CA98"
        strokeWidth="0.942068"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M153.308 372.599C139.282 240.36 193.242 51.4408 345.115 19.6024C473.298 -7.18544 587.994 35.7746 665.994 93.2756C757.069 160.415 844.176 268.221 879.355 367.365"
        stroke="#00CA98"
        strokeWidth="0.907176"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M131.458 367.95C124.488 230.984 186.351 55.7595 333.88 24.209C458.094 -2.26488 571.927 37.2322 650.528 94.6373C744.395 163.181 832.792 271.955 871.173 380.119"
        stroke="#00CA98"
        strokeWidth="0.872285"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M109.598 363.292C109.677 221.607 179.451 60.0597 322.636 28.8057C442.881 2.63717 555.85 38.68 635.063 95.9891C731.738 165.929 821.409 275.68 862.982 392.854"
        stroke="#00CA98"
        strokeWidth="0.837394"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M87.7476 358.642C94.8828 212.229 172.56 64.3682 311.401 33.4108C427.686 7.55625 539.792 40.1361 619.597 97.3493C719.073 168.676 810.026 279.413 854.8 405.606"
        stroke="#00CA98"
        strokeWidth="0.802502"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M65.8882 353.993C80.0715 202.852 165.651 68.6773 300.158 38.0165C412.473 12.4673 523.733 41.5754 604.123 98.7101C706.416 171.406 798.625 283.155 846.601 418.359"
        stroke="#00CA98"
        strokeWidth="0.767611"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M44.0371 349.336C65.2685 193.467 158.76 72.9782 288.922 42.6139C397.269 17.3787 507.77 42.8756 588.657 100.054C693.889 173.945 787.241 286.871 838.418 431.086"
        stroke="#00CA98"
        strokeWidth="0.723997"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22.1777 344.686C50.4659 184.089 151.86 77.2955 277.679 47.2191C382.056 22.2892 491.676 44.3667 573.183 101.414C681.189 176.745 775.849 290.604 830.228 443.838"
        stroke="#00CA98"
        strokeWidth="0.689105"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M0.327148 340.036C64.8762 38.0601 376.203 -22.9999 557.717 102.775C668.497 179.536 764.466 294.337 822.037 456.582"
        stroke="#00CA98"
        strokeWidth="0.654214"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <path
      d="M429.788 -15.1492C434.516 -3.15528 390.937 25.2638 332.45 48.3183C273.963 71.3727 222.716 80.3311 217.98 68.3285C213.252 56.3258 256.832 27.9155 315.318 4.86101C373.805 -18.1935 425.052 -27.1518 429.788 -15.1492Z"
      fill="url(#paint0_radial_decorative)"
      style={{ mixBlendMode: 'screen' }}
    />
    <defs>
      <radialGradient
        id="paint0_radial_decorative"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(322.241 26.6571) rotate(-21.51) scale(113.606 23.2377)"
      >
        <stop stopColor="white" />
        <stop offset="0.05" stopColor="#FFFCF4" />
        <stop offset="0.13" stopColor="#DBFFF6" />
        <stop offset="0.35" stopColor="#6C7E7A" stopOpacity="0.5" />
        <stop offset="0.52" stopColor="#23221E" stopOpacity="0.14" />
        <stop offset="0.59" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export default DecorativeBannerBackground;
